// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"StoryboardMenu-modulemenuWrapper3MN"};